export const AppImages = state => state.publicContent.AppImages
export const LoyaltyMilestones = state => state.publicContent.LoyaltyMilestones
export const WebVideos = state => state.publicContent.WebVideos
export const ArticleByName = (articles, name) =>
  articles?.length > 0 ? articles.find(a => a.name === name) : []
export const ArticleByIdentifier = (articles, contentId) =>
articles?.length > 0 ? articles.find(a => a.content_id__c === contentId) : []